import { noConditionData } from '@Components/RiskDetails/RiskDetails.component';
import {
	Column as RiskDetailsColumn,
	ColumnNoCD as RiskDetailsColumnNoCD,
	headerReactNodes as riskDetailsHeaderReactNodes,
} from './riskDetailsPagination';
import {
	FilterStoreState,
	IdCaption,
	SelectProps,
} from '@innovyze/lib_am_common';
import {
	filterByIdSelect,
	filterByMultipleIdSelect,
} from '@innovyze/lib_am_common/Reducers';

const gradeFilterOptions = (): IdCaption[] => [
	{ id: '0', caption: 'Negligible' },
	{ id: '1', caption: 'Low' },
	{ id: '2', caption: 'Medium' },
	{ id: '3', caption: 'High' },
	{ id: '4', caption: 'Extreme' },
];

const conditionFilterOptions = (): IdCaption[] => [
	{ id: '0', caption: 'No' },
	{ id: '1', caption: 'Yes' },
];

export const riskDetailsInitialState = (
	assetType: string,
): FilterStoreState => {
	const noCD = noConditionData(assetType);
	const headers = riskDetailsHeaderReactNodes(assetType, false);
	const grade =
		headers[noCD ? RiskDetailsColumnNoCD.Grade : RiskDetailsColumn.Grade];

	const selects: SelectProps[] = [
		{
			column: { id: grade.key, caption: grade.cell },
			options: gradeFilterOptions(),
			dataCy: grade.key,
			filterBy: filterByMultipleIdSelect,
			value: [],
			multiple: true,
		},
	];

	if (!noCD) {
		const condition = headers[RiskDetailsColumn.ConditionData];

		selects.push({
			column: { id: condition.key, caption: condition.cell },
			options: conditionFilterOptions(),
			dataCy: condition.key,
			filterBy: filterByIdSelect,
			value: '',
			multiple: false,
		});
	}

	return {
		query: '',
		filters: {},
		selects: selects.reduce((d, v) => ({ ...d, [v.column.id]: v }), {}),
	};
};
